import React, { useEffect, useState, useRef, useCallback } from "react"
import { useSwipeable } from 'react-swipeable'
import { useTheme } from '~/contexts/ThemeContext';
import { notBlank, imgSize } from '~/utils/helpers'
import { IconChevLeft, IconChevRight } from '~/components/icons/chevrons'

import { aria_btn } from "~/styles/app.module.scss"
import { cont, arrowbtn, scroll, scrollt, titles, bodycopy, fig, figcap } from "~/styles/pages/factory.module.scss"
import * as styles from "~/styles/carousel/carousel_fixed.module.scss"

const CarouselFixed = ({ carou_data, par_styles }) => {
  const { isMobile, isTouches } = useTheme()

  const { carousel, title, copy } = carou_data

  const [didLoad, setDidLoad] = useState(null)
  const [maxHeight, setMaxHeight] = useState(0)
  const [pos, setPos] = useState(0)
  const [lastPos, setLastPos] = useState(0)

  const wrapRef = useRef(null)
  const slideRef = useRef(null)

  const total = carousel && (carousel.length - 1)

  const getPerc = (delta) => {
    const timew = wrapRef.current.getBoundingClientRect().width
    const perc = ((delta)/timew)*100
    return perc < -100 ? -100 : perc > 100 ? 100 : perc
  }
  const [currTrans, setCurrTrans] = useState(0)
  const [change, setChange] = useState(0)
  const [deltaX, setDeltaX] = useState(0)
  
  useEffect(() => {
    if (deltaX === 0) return
    const intervalId = setInterval(() => {
      setDeltaX(prevDeltaX => prevDeltaX > 0 ? prevDeltaX - 1 : 0);
      setCurrTrans(prevTrans => Math.abs(prevTrans) <= 0 ? 0 : prevTrans - change);
    }, 1); 

    return () => {
      clearInterval(intervalId);
      if (deltaX <= 0 && currTrans <= -100) {
        setPos( pos + 1 > total ? pos : pos + 1 )
        setCurrTrans(0)
      }
      if (deltaX <= 0 && currTrans >= 100) {
        setPos( pos - 1 < 0 ? pos : pos - 1 )
        setCurrTrans(0)
      }
    };
  }, [deltaX, currTrans, change, pos, total]);

  const swipers = useSwipeable({
    onSwiping: (e) => {
      if (!isTouches) return
        
      if (e.dir === 'Right' && pos !== 0) setCurrTrans( getPerc(e.deltaX) )
      if (e.dir === 'Left' && pos !== total) setCurrTrans( getPerc(e.deltaX) )
    },
    onSwipedLeft: (e) => {
      if (!isTouches) return
      if (pos === total) return

      const delta = getPerc(e.absX)
      if ( delta > 30 ) {
        setChange(1)
        setDeltaX(100 - delta)
      } else {
        setChange(-1)
        setDeltaX(delta)
      }
    },
    onSwipedRight: (e) => {
      if (!isTouches) return
      if (pos === 0) return

      const delta = getPerc(e.absX)
      if ( delta > 30 ) {
        setChange(-1)
        setDeltaX(100 - delta)
      } else {
        setChange(1)
        setDeltaX(delta)
      }
    },
    preventScrollOnSwipe: true,
    trackTouch: true,
    delta: {
      up: 1000,
      down: 1000,
    },
  })

  const handleBack = () => {
    setLastPos(pos)
    setPos( pos - 1 < 0 ? pos : pos - 1 )

    if (!isMobile) unfix()
  }
  const handleForward = () => {
    setLastPos(pos)
    setPos( pos + 1 > total ? pos : pos + 1 )

    if (!isMobile) unfix()
  }
  
  const deskChange = useCallback(() => {
    const wrap = wrapRef.current
    const wrap_rect = wrap.getBoundingClientRect()
    const slide_rect = slideRef.current.getBoundingClientRect()

    const curr_scroll = wrap.scrollLeft
    const wind_mid = wrap_rect.width / 2
    const next_mid = slide_rect.left + (slide_rect.width / 2)
    const skipped = lastPos < pos ? next_mid < wind_mid : next_mid > wind_mid

    const getMid = (el) => {
      return el.getBoundingClientRect().left + (el.getBoundingClientRect().width / 2)
    }

    let inview = false
    if (skipped) {
      const arr = Array.from(document.querySelectorAll(`.${styles.fig}`))
      if (pos > lastPos ) {
        inview = arr.indexOf(arr.find(x => getMid(x) > wind_mid))
      } else if ( pos < lastPos ) {
        inview = arr.reverse().indexOf(arr.find(x => getMid(x) < wind_mid))
      }
    }

    if ( inview ) {
      setLastPos(inview)
      setPos(inview)
      return
    }
    const next_scroll = (slide_rect.left + curr_scroll) - (0.5 * (wrap_rect.width - slide_rect.width) )

    wrap.scrollTo({
      top: 0,
      left: next_scroll,
      behavior: 'smooth'
    });
  }, [pos, lastPos])

  useEffect(() => {
    if (isMobile || pos === 0 || !slideRef.current) return
    deskChange()
    
  }, [pos, isMobile, slideRef, deskChange])

  const unfix = () => {
    document.querySelector('html').style.overflow = ''
  }
  
  const handleScroll = () => {
    const wrap = wrapRef.current
    if ( !wrap ) return

    if (maxHeight === 0) {
      let new_max = 0
      wrap.querySelectorAll('figure').forEach(x => {
        let height = x.getBoundingClientRect().height 
        const img_h = x.querySelector('img')?.getBoundingClientRect()?.height || 0
        const cap_h = x.querySelector('figcaption')?.getBoundingClientRect()?.height || 0
        if (!isMobile) {
          height = img_h + cap_h + 15
        }
        if (height > new_max) new_max = height
      })
      if (new_max !== maxHeight) setMaxHeight(new_max)
    }
  }

  // const handleFixed = (e) => {
  //   wrapRef.current.scrollLeft = wrapRef.current.scrollLeft + e.deltaY
  //   const inside_width = wrapRef.current.scrollWidth - wrapRef.current.clientWidth - 2

  //   if (wrapRef.current.scrollLeft >= inside_width || wrapRef.current.scrollLeft <= 2) {
  //     unfix()
  //   }
  // }

  

  useEffect(() => {
    if ( typeof window === 'undefined' ) return
    window.addEventListener('scroll', handleScroll, { passive: true })
    if (!isMobile) window.addEventListener('resize', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
      if (!isMobile) window.addEventListener('resize', handleScroll)
    };
  });

  useEffect(() => {
    handleScroll()
    setDidLoad(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleScroll()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  useEffect(() => {
    setTimeout(() => {
      handleScroll()
    }, 300)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [didLoad])


  return (
    <div className={`${par_styles} ${styles.carousel_wr} ${styles.fixed_car}`}>
      {notBlank(title) && (
        <div className={cont}>
          <h2 
            className={titles} 
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </div>
      )}
      {didLoad && (
        <div className={styles.bleed} style={{position: 'relative'}} {...swipers}>
          <div className={[styles.carousel, styles.autoscroll].join(' ')} ref={wrapRef} style={{ height: maxHeight }}>
            {carousel.length > 0 && carousel.map( (item, index) => {
              
              const load_desk = !isMobile || (isMobile && !notBlank(item.image_mob))
              const load_mob = isMobile && notBlank(item.image_mob)

              let trans = 'none'
              
              if (isMobile ) {
                if (index < (pos - 1) || index > (pos + 1)) {
                  trans = index < pos ? '-100%' : '100%'
                } else {
                  trans = index < pos ? `${-100 + currTrans}%` : index > pos ? `${100 + currTrans}%` : `${currTrans}%`
                }
                trans = `translate(${trans},0)`
              }

              return (
                <figure 
                  key={`car1${index}`}
                  className={`${fig} ${styles.fig}`}
                  aria-hidden={!isMobile ? undefined : index === pos ? 'false' : 'true'}
                  ref={pos === index ? slideRef : undefined}
                  style={{
                    border: '1px solid transparent',
                    transform: trans
                  }}
                  tt={index}
                > 
                  {load_desk && (
                    <img 
                      className={styles.img}
                      src={imgSize(item.image,900)}
                      alt={notBlank(item.caption) ? item.caption.replace(/(<([^>]+)>)/gi, '') : ''}
                    />
                  )}
                  {load_mob && (
                    <img 
                      className={styles.img} 
                      src={imgSize(item.image_mob,900)}
                      alt={notBlank(item.caption) ? item.caption.replace(/(<([^>]+)>)/gi, '') : ''}
                    />
                  )}
                  <figcaption
                    className={figcap}
                    dangerouslySetInnerHTML={{ __html: item.caption }} 
                  />
                </figure>
              )
            })}
          </div>
          <div className={scroll}><div className={scrollt} style={{width: `${(pos / total) * 100}%`}}></div></div>
          <button 
            type="button"
            className={`${aria_btn} ${arrowbtn} ${styles.arrowbtn} ${pos > 0 ? '' : styles.off}`}
            aria-label="Scroll Back" 
            onClick={(e)=>{handleBack()}}
          >
            <IconChevLeft icon_classes="" />
          </button>
          <button 
            type="button"
            className={`${aria_btn} ${arrowbtn} ${styles.arrowbtn} ${styles.forw} ${pos < total ? '' : styles.off}`}
            aria-label="Scroll Forward" 
            onClick={(e)=>{handleForward()}}
          >
            <IconChevRight icon_classes="" />
          </button>
        </div>
      )}
      
      {notBlank(copy) && (
        <div className={cont}>
          <div 
            className={bodycopy} 
            dangerouslySetInnerHTML={{ __html: copy }} 
          />
        </div>
      )}
    </div>
  )
}

export { CarouselFixed }


